import { render, staticRenderFns } from "./teamHonorPost.vue?vue&type=template&id=58e76739&scoped=true"
import script from "./teamHonorPost.vue?vue&type=script&lang=js"
export * from "./teamHonorPost.vue?vue&type=script&lang=js"
import style0 from "./teamHonorPost.vue?vue&type=style&index=0&id=58e76739&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e76739",
  null
  
)

export default component.exports